module.exports = __webpack_public_path__ + "static/016-95d18c33319f1866547fb415c6cb8d26.jpg";